// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__268nn","info":"Note_info__2NLae","note":"Note_note__1kLz0","actions":"Note_actions__2iTO6"};